import { ITeam } from "./match";
import { IPlayer } from "./person";

enum TRANSFER_STATUS {
    TRANSFER = 1,
    LOAD = 2,
    FREE_TRANSFER = 3,
    LOAD_W_B = 4,
    END_OF_LOAD = 5,
    RETIRED = 6,
    RELEASED = 7,
    FREE_AGENT = 8,
    RENEWAL = 9
}

interface ITypeTransfer {
    id: TRANSFER_STATUS;
    name: string;
}

export interface ITransfer {
    id: number;
    date: number;
    type: ITypeTransfer;
    player: IPlayer;
    fTeam?: ITeam;
    tTeam?: ITeam;
    note?: string;
}